import { NgModule } from '@angular/core';
import { AdvalvasDetailModalComponent } from './advalvas-detail-modal/advalvas-detail-modal';
import { IonicModule } from 'ionic-angular';
import { MessageItemComponent } from './message-item/message-item';
import { MessageAttachmentOptionComponent } from './message-attachment-option/message-attachment-option';
import { TaskItemComponent } from './task-item/task-item';
import { UserItemComponent } from './user-item/user-item';
import { GroupItemComponent } from './group-item/group-item';
import { AddedUserGroupItemComponent } from './added-user-group-item/added-user-group-item';
import { ImagePreviewComponent } from './image-preview/image-preview';
import { TranslateModule } from '@ngx-translate/core';
import { MessageInfoItemComponent } from './message-info-item/message-info-item';
import { MessageInfoPanelComponent } from './message-info-panel/message-info-panel';
import { MessageInfoPanelItemComponent } from './message-info-panel-item/message-info-panel-item';
import { UserAvatarComponent } from './user-avatar/user-avatar';


const components = [
	AdvalvasDetailModalComponent,
	MessageItemComponent,
	MessageAttachmentOptionComponent,
	TaskItemComponent,
	UserItemComponent,
	GroupItemComponent,
	AddedUserGroupItemComponent,
	MessageInfoItemComponent,
	ImagePreviewComponent,
	MessageInfoPanelComponent,
	MessageInfoPanelItemComponent,
	UserAvatarComponent
];

const entryComponents = [
	AdvalvasDetailModalComponent,
	ImagePreviewComponent,
	MessageInfoPanelComponent
]


@NgModule({
	declarations: [
		...components
	],
	imports: [
		IonicModule,
		TranslateModule
	],
	entryComponents: [
		...entryComponents
	],
	exports: [
		...components
	]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts